/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Hooks React===================
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

// ==================Components===================
import MapNetwork from './MapNetwork';
import MenuButton from '../MenuButton';
import ModalExportQuery from '../ModalExportQuery';
import GridNetwork from './GridNetwork';

// ==================Style&IMG===================
import './style.scss';

// ==================Actions===================
import { fetchNetworkFullData, setNetworkName, setSaveNetworkArray } from '../../actions/network';
import { globalConfig } from '../../configuration/config';

function Network() {
  // =================HOOKS=================
  // const networkName = useParams();
  const dispatch = useDispatch();
  const dataAPI = useSelector((state) => state.dataAPI.stations.list);
  const { '*': slug } = useParams();
  const decoded = decodeURIComponent(slug || '');

  // ===============UseEffect================
  // at the starting page fetch data of list staton to the network in the url
  useEffect(() => {
    dispatch(fetchNetworkFullData(decoded.substring(5), globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    dispatch(setNetworkName(decoded.substring(5)));
  }, []);
  // construction of an array of network from a string
  useEffect(() => {
    const networkArray = [];
    if (dataAPI.length !== 0) {
      dataAPI.data.forEach((dataElement) => {
        const netwArray = dataElement.network.name.split(' & ');
        if (netwArray.includes(decoded.substring(5))) {
          networkArray.push(dataElement);
        }
      });
    }
    if (networkArray.length !== 0) {
      dispatch(setSaveNetworkArray(networkArray));
    }
  }, [dataAPI]);

  return (
    <>
      <MenuButton />
      <div className="network--container">
        <div className="network--map">
          <MapNetwork />
        </div>
        <div className="network--grid">
          <h1 className="network--name">{decoded.substring(5)}</h1>
          <GridNetwork />
        </div>
        <ModalExportQuery />
      </div>
    </>
  );
}

export default Network;
